// extracted by css-extract-rspack-plugin
export default {"dropdown":"_c712b280"};